import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function Investors({ children }) {
  return (
    <div>
      <CustomPageHeader icon='fire' text='Investors' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/index.js